import {get} from 'lodash';

export const setTDWidth = (w) => {
    return {
        width: `${w}px`,
        minWidth: `${w}px`,
        maxWidth: `${w}px`
    };
}

export const getStateBasedTitle = (dashboard) => {
    const district_state = get(dashboard, 'project.district.state', '');
    const state = get(dashboard, 'project.school.state', district_state);
    switch (state.toLowerCase()) {
        case 'ca':
            return {
                skill: 'Student Achievement - Math Practices/ELA Targets',
                category: 'Student Achievement - Math/ELA CAASPP Claims',
                s_table: 'Individual Student Achievement - Math Practices/ELA Targets',
                domain: 'Student Achievement - Math Domains',
                d_table: 'Individual Student Achievement - Math Domains'
            };
        case 'fl':
            return {
                skill: 'Student Achievement - B.E.S.T Mathematical Thinking and Reasoning Standards',
                s_table: 'Individual Student Achievement - B.E.S.T Mathematical Thinking and Reasoning Standards',
                domain: 'Student Achievement - Math Strands',
                d_table: 'Individual Student Achievement - Math Strands'
            };
        case 'ok':
            return {
                skill: 'Student Achievement - Mathematical Actions and Processes',
                s_table: 'Individual Student Achievement - Mathematical Actions and Processes',
                domain: 'Student Achievement - Math Domains',
                d_table: 'Individual Student Achievement - Math Domains'
            };
        case 'tx':
            return {
                skill: 'Student Achievement - TEKS Mathematical Process Standards',
                s_table: 'Individual Student Achievement - TEKS Mathematical Process Standards',
                domain: 'Student Achievement - Math Domains',
                d_table: 'Individual Student Achievement - Math Domains'
            };
        default:
            return {
                skill: 'Student Achievement',
                category: 'Student Achievement',
                s_table: 'Individual Student Achievement',
                domain: 'Student Achievement - Math Domains',
                d_table: 'Individual Student Achievement - Math Domains'
            };
    }
}

export const getPracticeBasedTitle = (dashboard) => {
    const practice_codes = get(dashboard, 'practices', []);
    const skill_titles = practice_codes.map(practice_code => {
        switch (practice_code) {
            case 'ccmps':
                return 'Math Practices';
            case 'bestmtrs':
                return 'B.E.S.T Mathematical Thinking and Reasoning Standards';
            case 'teksmps':
                return 'TEKS Mathematical Process Standards';
            case 'ela':
                return 'ELA Targets';
            case 'omap':
                return 'Mathematical Actions and Processes';
            case 'bestela':
                return 'B.E.S.T. ELA Standards';
            case 'mindsets':
                return 'Mindsets Future-Ready Skills';
            default:
                return 'Unknown';
        }
    });
    let category_title;
    if (practice_codes.includes('mindsets')) {
        category_title = 'Critical Thinking Skills';
    } else {
        category_title = 'Math/ELA CAASPP Claims';
    }

    return {
        skill: 'Student Achievement' + (skill_titles.length ? ' - ' + skill_titles.join('/') : ''),
        category: 'Student Achievement - ' + category_title,
        s_table: 'Individual Student Achievement' + (skill_titles.length ? ' - ' + skill_titles.join('/') : ''),
        domain: 'Student Achievement - Math Domains',
        d_table: 'Individual Student Achievement - Math Domains'
    };
}
